export default __webpack_public_path__ + "27d9ce1aee5a3903af5bb0a9324cea9d.png";